import React, { Component } from "react";
import { Button, Modal, Toast } from "react-bootstrap";
import FormDataAsetCom from "../components/FormDataAset_Com";
import SideBar from "../components/SideBar_Com";
import { getTime } from "../logic/handler";

class FormDataAset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showToast: [],
      toast_data: [],
      showModal: false,
      modalData: {},
    };
  }

  close(index, pos) {
    //destroy
    let show_arr = [...this.state.showToast];
    show_arr[index] = false;
    this.setState(
      {
        showToast: show_arr,
      },
      this.destroy(pos)
    );
  }

  destroy(position) {
    //nge rerender ketika masih ada yg di show apakah ga bakal masalah?
    let toast_data = [...this.state.toast_data];
    toast_data.splice(position, 1, null);
    this.setState({
      toast_data: toast_data,
    });
  }

  move = () => {
    this.props.history.push("/TableAdminAset");
  };

  generateToast = (status, message) => {
    let idx = this.state.showToast.length;
    let header = "";
    let header_class = "";
    switch (status) {
      case 0: //success
        header_class = "success";
        header = "Success!!";
        break;
      case 1: //error from input
        header_class = "warning";
        header = "Error!!";
        break;
      case 2: //error from server
        header_class = "danger";
        header = "Error!!";
        break;
      default:
        header_class = "";
        header = "Unknown";
        break;
    }
    let data = {
      class: header_class,
      header: header,
      msg: message,
      idx: idx,
      pos: this.state.toast_data.length,
    };
    this.setState({
      toast_data: this.state.toast_data.concat(data),
      showToast: this.state.showToast.concat(true),
    });
  };

  showModal = (type, data) => {
    this.setState({
      showModal: true,
      modalData: {
        goods_type: data.goods_type,
        no_certificate: data.no_certificate,
        type: type,
      },
    });
  };

  render() {
    return (
      <div className="home">
        <SideBar />
        <div className="toast_container">
          {this.state.toast_data.map((item) => {
            return (
              item !== null && (
                <Toast
                  animation
                  className={item.class || "unknown"}
                  show={this.state.showToast[item.idx]}
                  onClose={() => this.close(item.idx, item.pos)}
                  autohide
                  delay={5000}
                >
                  <Toast.Header>
                    <strong className={"mr-auto "}>
                      {item.header || "Unknown"}
                    </strong>
                    <small>{getTime()}</small>
                  </Toast.Header>
                  <Toast.Body>
                    {item.msg ||
                      "Some undocummented error occured. Please contact the administrator to look at this problem"}
                  </Toast.Body>
                </Toast>
              )
            );
          })}
        </div>
        <Modal show={this.state.showModal} onHide={this.move} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Sukses!!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.modalData.type === "input" ? (
              <div>
                <p>Aset dengan data berikut ini:</p>
                <ul>
                  <li>Jenis Barang : {this.state.modalData.goods_type}</li>
                  <li>
                    No. Sertifikat: {this.state.modalData.no_certificate}
                  </li>
                </ul>
                <p>Telah berhasil dibuat.</p>
              </div>
            ) : (
              <p>
                Data aset telah berhasil diubah.
              </p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.move}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="main">
          <FormDataAsetCom
            {...this.props}
            generateToast={this.generateToast}
            showModal={this.showModal}
          />
        </div>
      </div>
    );
  }
}

export default FormDataAset;
